export default {
  getAttr: (state) => (name) => {
    return state[name]
  }
}
